import * as Yup from 'yup';

export const DEAL_TYPES = [
  { value: 1, label: 'Straight Refi' },
  { value: 2, label: 'Add' },
  { value: 3, label: 'Drop' },
  { value: 4, label: 'All' },
  { value: 5, label: 'Add Or Drop' },
];

export enum DEAL_TYPES_VALUES {
	'StraightRefi' = 1,
	'Add' = 2,
	'Drop' = 3,
	'All' = 4,
	'AddOrDrop' = 5
}

export const stateTitleDocumentValidationSchema = Yup.object().shape({
  dealBorrowerType: Yup.number().nullable().required(),
  documentName: Yup.string().nullable().required(),
  state: Yup.string().nullable().required(),
});
